import { Button, Input } from "antd";
import { FilterOutlined, PlusOutlined } from "@ant-design/icons";
import { useState } from "react";

import { useModalContext, useTasksContext } from "../../providers";
import { useTaskFilters } from "../../hooks/useTaskFilters";

import { HomeLayout } from "../../layouts";

import CreateTaskModal from "../../components/Modals/CreateTask/CreateTask";
import DeleteTaskPopup from "../../components/Modals/DeleteTask/DeleteTask";
import ReactivateTaskPopup from "../../components/Modals/ReactivateTask/ReactivateTask";
import TaskFiltersForm from "../../components/FiltersForm/TaskFiltersForm";
import AppliedTaskFilters from "../../components/FiltersForm/AppliedTaskFilters";
import DocsList from "./DocsList/DocsList";

import styles from "./Home.module.css";

const { Search } = Input;

const Home = () => {
  const { openCreateTask } = useModalContext();
  const { tasks, isLoading, addNewTask } = useTasksContext();
  const [showFilterModal, setShowFilterModal] = useState(false);
  
  const {
    searchTerm,
    setSearchTerm,
    appliedFilters,
    filteredTasks,
    handleApplyFilters,
    handleRemoveFilter,
    handleClearAllFilters
  } = useTaskFilters({ tasks });

  const hasFiltersApplied = () => {
    return searchTerm.trim() !== "" || 
           appliedFilters.criteria.length > 0 ||
           appliedFilters.status.length > 0 ||
           appliedFilters.taskValidation.length > 0 ||
           appliedFilters.creationDate !== null;
  };

  return (
    <HomeLayout>
      <main className={styles.main}>
        <div className={styles.homeContainer}>
          <div className={styles.homeHeader}>
            <div className={styles.homeHeaderContent}>
              <div className={styles.homeHeaderTitle}>
                <h1 style={{ margin: 0 }}>Inici.</h1>
                <h3 className={styles.subtitle} style={{ margin: 0 }}>
                  Crea tasques d'anonimització, consulta el teu històric i descarrega els fitxers
                </h3>
              </div>
              <Button
                onClick={openCreateTask}
                className="lg normal flex-r-center"
                size="large"
                type="primary"
              >
                <PlusOutlined />
                Crear tasca
              </Button>
            </div>
          </div>
          <div className={styles.homeContent}>
            <div className={styles.homeContentHeader}>
              <span>{filteredTasks.length} {filteredTasks.length === 1 ? "tasca" : "tasques"}</span>
              <div>
                <Search 
                  className={styles.search} 
                  placeholder="Cercar" 
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  allowClear
                />
                <Button 
                  icon={<FilterOutlined />} 
                  className={styles.filterButton}
                  onClick={() => setShowFilterModal(true)}
                />
              </div>
            </div>
            <AppliedTaskFilters
              filters={appliedFilters}
              onRemoveFilter={handleRemoveFilter}
              onClearAll={handleClearAllFilters}
            />
            <DocsList 
              tasks={filteredTasks} 
              loading={isLoading}
              hasFilters={hasFiltersApplied()}
            />
          </div>
        </div>
      </main>
      <CreateTaskModal
        addTask={addNewTask}
      />
      <DeleteTaskPopup />
      <ReactivateTaskPopup />
      <TaskFiltersForm
        visible={showFilterModal}
        onCancel={() => setShowFilterModal(false)}
        onApply={handleApplyFilters}
        initialFilters={appliedFilters}
      />
    </HomeLayout>
  );
};

export default Home;